import { Component, OnInit,AfterViewInit } from '@angular/core';
declare var $: any;
import {Md5} from 'ts-md5/dist/md5';
import { NgForm } from '@angular/forms';
import { commonService } from '../../service/common.service';
import { userService } from '../../service/user.service';
//import { FrontNavigationComponent } from '../../shared/header-front-navigation/navigation.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {ActivatedRoute} from "@angular/router";
import { FileSelectDirective,FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import {Globals } from '../../globals';
import { sessionService } from '../../service/session.service';
import { NgxPermissionsService } from "ngx-permissions";
@Component({
  selector: 'app-vprofile',
  templateUrl: './vprofile.component.html',
  styleUrls: ['./vprofile.component.css'],
  providers:[userService,Globals,sessionService]
})
export class VprofileComponent implements OnInit,AfterViewInit {
    constructor(private router:Router,private route: ActivatedRoute,private commonservice:commonService,private userservice:userService,private global: Globals, private _session:sessionService) {
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
}
  tabactive:any;
  form:any;
  msg="";
  msgclass="success";
  statebox:any;
  citybox:any;
  isError=false;
  streambox:any;
  profile:any;
  profileimage:any;
  attachmentUrl =this.global.siteUrl+'file/upload?folder='+this.global.profileFolder+'&mediaFor=userProfile';
  uploader:FileUploader=new FileUploader({url:this.attachmentUrl,authToken:sessionStorage.getItem('_to')});
  fileExt: string = "JPG, JPEG, PNG,doc,docx,txt,ppt,pptx";
  isclickbuttonRegisterprofile = false;
  isclickbuttonRegisterabout = false;
  isclickbuttonRegistersetting = false;
  progress:any=0
  ngOnInit() {
    
    this.getstate();
    this.getstreamtype();
    this.tabactive=1;
    this.form={};
    this.profile={};
    this.profile.gender="0";
    
    this.profile=this.commonservice.user;
    if(this.commonservice.user['faculty']){
      this.profile.stream=this.commonservice.user['faculty'].streamId;
    }
    
    if(this.profile.pState) this.onChangeState('',this.profile.pState);
    this.form.currentpassword={};
    this.form.password={};  
    this.form.cpassword={};
    this.profileimage={};
  }

  openCity(tabid){
    this.tabactive=tabid;

  }
  onSubmit(f: NgForm) {
    this.isclickbuttonRegistersetting=true;
    this.form.currentpassword.error="";
    this.form.password.error="";
    this.form.cpassword.error="";
    if(f.valid==true){
      if(Md5.hashStr(f.value.currentpassword)!=this.commonservice.user.password){
        this.form.currentpassword.error="Current Password not match";
      }else{
        this.userservice.changeuserpassword({password:f.value.password},this.commonservice.user.id).subscribe((data:any)=>{
          if(data.error==0){
            this.isclickbuttonRegistersetting=false;
          this.commonservice.user.password=  Md5.hashStr(f.value.password);
          this.commonservice.updateUsersessionStorage(this.commonservice.user);
          this.msg="Password has been changed successfully!";
          this.msgclass="success";
          }
        },(error : HttpErrorResponse)=>{      
          this.msg="internal server error!";
          this.msgclass="danger";
        }) 

      }

    }else{
      this.isclickbuttonRegistersetting=false;
      if(!f.value.currentpassword){
        this.form.currentpassword.error="Please Enter Current Password";
      }

      if(!f.value.password){
        this.form.password.error="Please Enter Password";

      }else if(f.value.cpassword!=f.value.password){
        this.form.cpassword.error="Confirm Password not match";
      }
      
     
    }
  }

  updateProfile(profiledata:NgForm){
    this.isclickbuttonRegisterprofile=true;
    let user={}
    for(var i in profiledata.value){
      user[i]=profiledata.value[i];

    }
    user['userType']=this.commonservice.user.userType;
    user['id']=this.commonservice.user.id;
    user['profileImage']=this.profileimage.id;
    this.userservice.updateuser(user).subscribe((data:any)=>{
        if(data.error==0){
          this.isclickbuttonRegisterprofile=false;   
          if(this.profileimage.id > 0){
            this.commonservice.user['photo']=this.profileimage.uploadname;
          }
         this.commonservice.user.state.pstate_name = this.getStateNameFromStateList(this.statebox,this.commonservice.user.pState);
         
          if(this.profile.stream){
            this.commonservice.user.faculty.streamId = this.profile.stream;
          }
         if(this.commonservice.user.pCity){
           this.commonservice.user.city.pcity_name = this.getCityNameFromCityList(this.citybox,this.commonservice.user.pCity);
          }
          
          this.commonservice.updateUsersessionStorage(this.commonservice.user);
          this.uploader.queue=[];
          this.msg="Profile has been saved successfully";
          this.router.navigateByUrl('user/viewprofile');
          
        }
    },(error : HttpErrorResponse)=>{      
      this.msg="internal server error!";
      this.msgclass="danger";
    });   
  }
  
  updateAbout(profiledata:NgForm){
    this.isclickbuttonRegisterabout=true;
    let user={}
    for(var i in profiledata.value){
      user[i]=profiledata.value[i];
   }
    user['id']=this.commonservice.user.id;
   
    this.userservice.updateuser(user).subscribe((data:any)=>{
        if(data.error==0){
          this.isclickbuttonRegisterabout=false;   
         this.commonservice.updateUsersessionStorage(this.commonservice.user);
          //this.uploader.queue=[];
          this.msg="Profile has been saved successfully";
          this.router.navigateByUrl('user/viewprofile');
          
        }
    },(error : HttpErrorResponse)=>{      
      this.msg="internal server error!";
      this.msgclass="danger";
    });   
  }


  ngAfterViewInit() {
    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
   });
  }

  closenotification(variable){
   this[variable]="";

  }


  onFileChanged(event) {
    //this.uploader.uploadAll();
    this.profileimage={};
        this.uploader.queue[0].upload();
        this.progress=1;
        this.sleep(2000).then(() => {
          if(this.uploader.queue[0].isSuccess){
          }
          this.uploader.queue=[];
          console.log('test123');
        })
   }
   private sleep (time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
      let data = JSON.parse(response); //success server response
        if(data.error==0){
          this.progress=0;
          this.profileimage=data.result.mediaDetail;       
        }       
    }
  
    onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        let error = JSON.parse(response); //error server response
         }

    
    getstate(){
    this._session.userstate().subscribe((data : any)=>{
            if(data.error==0){ 
              this.statebox = data.results;   
            }else{
              if(data.message=="Failed to authenticate token."){
                this.router.navigate(['/admin']);
              }else{
                this.msg = data.message;
                this.isError = true;
              }
            }
      },
        (error : HttpErrorResponse)=>{
          this.isError = true;
          this.msg="internal server error!";
        });
  
  }

  onChangeState($event,stateValue){
    //console.log(stateValue);
    //console.log('yeestateid');
      this._session.usercity(stateValue).subscribe((data : any)=>{
              
        if(data.error==0){ 
          
          this.citybox = data.results;
              
        }else{
          if(data.message=="Failed to authenticate token."){
            //sessionStorage.clear();
            //localStorage.clear();
            this.router.navigate(['/admin']);
          }else{
            this.msg = data.message;
            this.isError = true;
          }
    
        }
    },
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
    });
        
    }

    getStateNameFromStateList(statelist, stateId){
      for(let l of statelist){
        if(l.state_id==stateId) return l.name; 
      }
    }

    getCityNameFromCityList(citylist, cityId){
      for(let l of citylist){
        if(l.city_id==cityId) return l.name; 
      }
    }

    getstreamtype(){
      this._session.getstream().subscribe((data : any)=>{     
        if(data.error==0){ 
          this.streambox= data.results;   
        }else{
          if(data.message=="Failed to authenticate token."){
            sessionStorage.clear();
            localStorage.clear();
            this.router.navigate(['/admin']);
          }else{
           this.msg = data.message;
           this.isError = true;
          }
        }
    },
    (error : HttpErrorResponse)=>{
     this.isError = true;
     this.msg="internal server error!";
    });    
    }


}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/vprofile/vprofile.component.ts